module.exports = "<div class=form-field> <div ng-if=!$ctrl.hideLabel ng-class=[$ctrl.labelClass] class=form-field-label> {{ $ctrl.label }} </div> <div ng-class=[$ctrl.inputClass] class=form-field-input> <div ng-repeat=\"option in $ctrl.options\" class=\"checkbox-list-item checkbox-col{{ $ctrl.numColumns }}\"> <toggle ng-model=option.isChecked class=circle-toggle off=\"\" on=\"\"> </toggle> {{ option[$ctrl.displayProp] }} </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/form-fields/checkbox-list-field/checkbox-list-field.html
// module id = 342
// module chunks = 0